import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { faUserCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MicroFrontendContext from '../../../context/MicroFrontendContext';
import CollapsingMenu from '../../Sidebar/CollapsingMenu';
import MenuLink from '../../Sidebar/MenuLink';
import SubMenu, { SubMenuListItem as Li } from '../../Sidebar/SubMenu';
import hasProductClaims, {
	proClaim,
	reactClaim
} from '../utils/hasProductClaims';

const AccountMenu = ({
	title,
	onClick,
	isOpen,
	isCollapsed,
	productClaims
}) => {
	const { user } = useContext(MicroFrontendContext);

	return (
		user.roles.admin &&
		hasProductClaims(productClaims, [proClaim, reactClaim]) && (
			<CollapsingMenu
				title={title}
				direction="up"
				onClick={onClick}
				isOpen={isOpen}
				isCollapsed={isCollapsed}
				Icon={() => (
					<FontAwesomeIcon
						style={{ pointerEvents: 'none' }}
						fixedWidth
						size="lg"
						icon={faUserCircle}
					/>
				)}
			>
				<SubMenu label={title}>
					<Li>
						<MenuLink to="/shipments/manage-users">
							Manage Users
						</MenuLink>
					</Li>
					{/* <Li> */}
					{/*	<MenuLink to="/x2">Logout</MenuLink> */}
					{/* </Li> */}
				</SubMenu>
			</CollapsingMenu>
		)
	);
};

AccountMenu.propTypes = {
	title: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	isOpen: PropTypes.bool.isRequired,
	isCollapsed: PropTypes.bool,
	productClaims: PropTypes.arrayOf(PropTypes.string).isRequired
};

AccountMenu.defaultProps = {
	isCollapsed: false
};

export default AccountMenu;
